<div
	class="inline-flex cursor-inherit"
	#triggerElement
	cdkOverlayOrigin
	#trigger="cdkOverlayOrigin"
	(mouseenter)="show()"
	(mouseleave)="hide()"
	aria-haspopup="true"
	[attr.aria-expanded]="isOpen">
	<ng-content></ng-content>
</div>

<ng-template
	cdkConnectedOverlay
	[cdkConnectedOverlayOrigin]="trigger"
	[cdkConnectedOverlayOpen]="isOpen && hasContent"
	[cdkConnectedOverlayPositions]="positions"
	[cdkConnectedOverlayPush]="true"
	[cdkConnectedOverlayViewportMargin]="8"
	(overlayOutsideClick)="forceClose()"
	(detach)="forceClose()">
	<div
		#panelElement
		[@transformPopover]
		(mouseenter)="show()"
		(mouseleave)="hide()"
		class="z-[1000] pointer-events-auto m-2"
		[class]="
			panelTemplate
				? ''
				: 'bg-surface p-4 rounded-[var(--app-radius-md)] border border-gray-200 max-w-[360px] max-h-[400px] overflow-y-auto overflow-x-hidden'
		">
		@if (panelTemplate) {
			<ng-container [ngTemplateOutlet]="panelTemplate"></ng-container>
		} @else {
			@for (section of sections; track $index) {
				@switch (section.type) {
					@case (PopoverSectionType.TEXT) {
						@for (item of section.items ?? []; track $index) {
							<p class="text-xs mb-2 leading-4 text-gray-700 last:mb-0">{{ item }}</p>
						}
					}
					@case (PopoverSectionType.LIST) {
						<ul class="list-disc pl-5 text-xs mb-2 leading-4 text-gray-700 last:mb-0">
							@for (item of section.items ?? []; track $index) {
								<li class="mb-1 last:mb-0">{{ item }}</li>
							}
						</ul>
					}
					@case (PopoverSectionType.TABLE) {
						<table class="popover-table">
							@if (section.headers?.length) {
								<thead>
									<tr>
										@for (header of section.headers; track $index) {
											<th>{{ header }}</th>
										}
									</tr>
								</thead>
							}
							<tbody>
								@for (row of section.rows ?? []; track $index) {
									<tr>
										@for (cell of row; track $index) {
											<td>
												@if (isIconCell(cell)) {
													<span class="popover-icon-row">
														@for (icon of cell.icons; track $index) {
															@if (icon.icon === 'progress_clock') {
																<svg class="popover-progress-clock" viewBox="0 0 24 24" width="16" height="16">
																	<path class="clock-fill" d="M 12 12 L 12 2 A 10 10 0 1 1 2 12 Z" />
																</svg>
															} @else {
																<mat-icon
																	[fontSet]="icon.fontSet ?? 'material-symbols-outlined'"
																	class="popover-status-icon"
																	[class]="iconStateClass(icon.state)">
																	{{ icon.icon }}
																</mat-icon>
															}
															@if (!$last) {
																<span class="popover-icon-separator">-</span>
															}
														}
													</span>
												} @else {
													{{ cell }}
												}
											</td>
										}
									</tr>
								}
							</tbody>
						</table>
					}
				}
			}
		}
	</div>
</ng-template>
